import { render } from "./CompleteAlert.vue?vue&type=template&id=aaf3ae02"
import script from "./CompleteAlert.vue?vue&type=script&lang=js"
export * from "./CompleteAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__